import { AreaComumDiaStatus } from "core/features/area-comum/typings";
import { createGlobalStyle } from "styled-components";
import colors from "theme/colors";

const afterStyle = (bg: string) => `
    display: block;
    position: absolute;
    right: 5%;
    bottom: 10%;
    margin: auto;
    content: '.';
    width: 8px;
    height: 8px;
    background-color: ${bg};
    border-radius: 9999px;
`;
export const FullCalendarGlobalStyle = createGlobalStyle`
    .event-${AreaComumDiaStatus.Bloqueado} {
        position: relative;
        color: gray !important;
        cursor: not-allowed;
    }

    .event-${AreaComumDiaStatus.Bloqueado}::after {
        ${afterStyle(colors.cyan)}
    }

    .event-${AreaComumDiaStatus.Ocupado} {
        position: relative;
    }

    .event-${AreaComumDiaStatus.Ocupado}::after {
        ${afterStyle("#FF1133")}
    }
    
    .event-${AreaComumDiaStatus.Parcialmente} {
        position: relative;
        cursor: pointer;
    }

    .event-${AreaComumDiaStatus.Parcialmente}::after {
        ${afterStyle(colors.yellow500)}
    }

    .event-${AreaComumDiaStatus.Livre} {
        position: relative;
        cursor: pointer;
    }

    .event-selected {
        background-color: ${colors.blue100} !important;
    }
    .event-unavailable {
        opacity: .25;
        cursor: not-allowed !important;
    }

/* 

    .event-unavailable {
        opacity: .25;
        cursor: not-allowed !important;
    }

    .event-unavailable * {
        cursor: not-allowed !important;
    } */

    .fc-daygrid-day-top {
        opacity: 1 !important;
    }

`;
